import axios from "axios";
import { base } from "../base";

export const claimAttribution = async (attribution) => {
  const response = await axios({
    method: "POST",
    url: `${base}/api/attribution/claim`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: { attribution },
  });
  return response;
};

export const verifySubscriptionTransaction = async (reference) => {
  const response = await axios({
    method: "GET",
    url: `${base}/api/subscription/transaction/verify/${encodeURIComponent(reference)}`,
  });
  return response;
};
